module.exports = __webpack_public_path__ + "static/media/CredIESNew.7adb0ec4.svg";